<template>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
  <div class="list-tab has-radius-top-left">
    <div class="has-background-white is-flex is-justify-content-flex-end px-3 py-2">
      <button class="has-background-black-bis has-text-white button" :disabled="!editMode || !canAlterCompanyColors" @click="setDefaultColors">
        Set Default
      </button>
      <div class="is-divider-vertical"></div>
      <button class="button p-0 has-text-black-bis" @click="isActivityActive = true">
        <i class="icon-activityhistory"></i>
      </button>
    </div>
    <div class="column">
      <div class="columns">
        <div class="column " v-for="(tab, index) in colorData" :key="index">
          <div class="has-background-grey-lighter color-section-column">
            <div class="column">
              <div class="columns is-align-items-center">
                <div class="column is-flex is-flex-direction-row is-align-items-center">
                   <div class="tab-icon  is-flex is-align-items-center is-justify-content-center">
                        <i :class="tab.icon" class="has-text-white"></i>
                      </div>
                      <h3 class="has-text-black-bis is-size-3 has-text-weight-bold line-height">{{ tab.title }}</h3>
                </div>
                <div class="column is-narrow">
                    <div class="buttons">
                      <div v-if="canAlterCompanyColors && (!editMode || selectedIndexforEdit !== index)">
                        <button class="button p-0 has-text-black-bis" @click="editColor(index)">
                          <i class="icon-edit"></i>
                        </button>
                      </div>
                      <div v-if="canAlterCompanyColors && editMode && selectedIndexforEdit === index" class="buttons">
                        <button class="button is-outlined is-danger p-0" @click="closeColorPicker(tab)">
                          <i class="icon-close"></i>
                        </button>
                        <button class="button is-success has-text-white p-0" @click="saveColorSchema()">
                          <i class="icon-checkmark"></i>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
              <div class="is-divider my-2"></div>
              <div class="columns mt-3" v-if="dataLoaded">
                <div class="column">
                  <div v-for="item in tab.data" :key="item.model">
                    <div class="columns is-multiline">
                      <div class="column is-12 is-flex is-align-items-center" >
                        <div @click="openColorPicker(item, index, item.model)" class="color-tag is-clickable" v-if="canAlterCompanyColors && editMode && selectedIndexforEdit === index">
                          <span v-color-contrast="item.color">
                          </span>
                        </div>
                        <div class="color-tag" v-if="editMode && selectedIndexforEdit !== index">
                          <span v-color-contrast="item.color"></span>
                        </div>
                        <div v-if="!editMode" class="color-tag">
                          <span v-color-contrast="item.color"></span>
                        </div>
                        <span class="is-size-3 has-text-weight-semibold">{{ item.label }}</span>

                      </div>
                      <div class="column is-12 hide-triangle is-radius-large mb-3"
                        v-if="canAlterCompanyColors && selectedIndex === index && selectedModel === item.model">
                        <div class="is-flex is-align-items-center has-background-white is-border-radius-sm is-justify-content-space-between">
                           <color-picker :edit="true" :colorValue="stageColor" :isCompColors="true" :isAdvancedColors="isAdvancedColors"
                            @update:color="($event) => updateColor($event, item, tab)" :moduleLabel="item.label" @close-advanced-colors="isAdvancedColors = false"/>
                          <button class="button has-background-black-bis has-text-white px-0 mr-3 is-large" @click="openAdvancedColors(tab)" v-tooltip="'Advanced Colors'">
                                <i class="icon-settings"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <activity-slider
      :isActive="isActivityActive"
      :id="companyId"
      module="Company"
      :company="companyId"
      @update:isActive="isActivityActive = false"
    />
  </div>
</template>
<script>

import { onMounted, reactive, toRefs, ref, computed, watch } from 'vue';
import { useStore } from "vuex";
import _ from 'lodash';
import MfColorPicker from '@/components/MfColorPicker.vue';
import Companies from '@/models/Companies';
import ActivitySlider from '@/components/ActivitySlider.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';


export default {
  name: 'CompanyColors',
  props: {},
  components: {
    'color-picker': MfColorPicker,
    ActivitySlider,
  },

  setup(props, { emit }) {
    const store = useStore();
    const { getPermissionValues } = PermissionMixin();
    const state = reactive({
      colorSchema: {},
      moduleData: {},
      edit: false,
      stageColor: '',
      dataLoaded: false,
      moduleLabel: '',
      company: {},
      activeTabIndex: 0,
      isLoading: false,
      colorData: tabs,
      selectedIndex: null,
      selectedModel: 'prefab',
      isActivityActive: false,
      editMode: false,
      selectedIndexforEdit: null,
      isAdvancedColors: false,
    });

    const tabs = [
      {
        title: 'Prefab Packages',
        model: 'prefab-packages',
        icon: 'icon-projectplanner',
        data: [
          {
            model: 'prefab',
            label: 'All Prefab Packages',
          }
        ],
      },
      {
        title: 'Material Orders',
        model: 'material-orders-colors',
        icon: 'icon-materialmanager',
        data: [
          {
            model: 'preparation',
            label: 'Requesting',
          },
          {
            model: 'ordering',
            label: 'Ordering',
          },
          {
            model: 'sourcing',
            label: 'Sourcing',
          },
        ],
      },
      {
        title: 'Production Orders',
        model: 'production-orders-colors',
        icon: 'icon-productionmanager',
        data: [
          {
            model: 'coordination',
            label: 'Coordination',
          },
          {
            model: 'detailing',
            label: 'Detailing',
          },
          {
            model: 'manufacturing',
            label: 'Manufacturing',
          },
          {
            model: 'qa',
            label: 'Quality Assurance',
          },
          {
            model: 'mixColor',
            label: 'Mixed',
          },
        ],

      },
      {
        title: 'Shipping Orders',
        model: 'shipping-orders-colors',
        icon: 'icon-logisticsmanager',
        data: [
          {
            model: 'notStarted',
            label: 'Scheduled',
          },
          {
            model: 'inTransit',
            label: 'In Transit',
          },
          {
            model: 'inStorage',
            label: 'In Storage',
          },
          {
            model: 'fulfilled',
            label: 'Complete',
          },
          {
            model: 'releasedToInventory',
            label: 'Inventory',
          },
          {
            model: 'mixDelivery',
            label: 'Mixed Shipments',
          },
          {
            model: 'consumed',
            label: 'Consumed',
          },
          {
            model: 'unScheduled',
            label: 'Unscheduled',
          },

        ],
      },
    ];
    const openColorPicker = (item, index, model) => {
      state.selectedIndex = index;
      state.selectedModel = item.model;
      state.stageColor = item.color;
    };

    const updateColor = async (selectedColor, module, tab) => {
      _.set(state.company.colorScheme, module.model, selectedColor);
      state.colorData.forEach(cData => {
        if (cData.model === tab.model) {
          cData.data.forEach(item => {
            if (item.model === module.model) {
              item.color = selectedColor;
            }
          });
        }
      });
      state.isAdvancedColors = false;
    }

    const companyId = computed(() => store.state.userData?.company || '');
    const canAlterCompanyColors = computed(() => !getPermissionValues({
      permissionModule: 'app&projects',
      type: 'companyColors',
      project: { _id: store.state.userData?.company || '000000000000000000000000' },
    }));
    const saveColorSchema = async () => {
      if (!canAlterCompanyColors.value) {
        return;
      }
      try {
        state.isLoading = true;
        state.company.colorScheme.company = state.company._id;
        await Companies.saveColor(state.company.colorScheme);
        await loadData();
      } catch (error) {
        console.error('Error saving color schema:', error);
      } finally {
        state.editMode = !state.editMode;
        state.selectedIndex = null;
        state.selectedModel = '';
        state.isLoading = false;
      }
    }

    const setDefaultColors = async () => {
      if (!state.editMode || !canAlterCompanyColors.value) {
        return;
      }
      try {
        state.isLoading = true;
        state.company.colorScheme = {
          ...(state.company.colorScheme || {}),
          ...Companies.defaultColorSchemes(),
          company: state.company._id,
        };
        await Companies.saveColor(state.company.colorScheme);
        await loadData();
      } catch (error) {
        console.error('Error setting default color schema:', error);
      } finally {
        state.editMode = false;
        state.selectedIndex = null;
        state.selectedModel = '';
        state.isAdvancedColors = false;
        state.isLoading = false;
      }
    }
    const loadData = async () => {
      try {
        const userCompany = await Companies.getOne(store.state.userData.company);
        state.company = userCompany;
        state.colorSchema = state.company.colorScheme || {};
        state.colorData = tabs;
        state.colorData.forEach(cData => {
          cData.data.forEach(item => {
            item.color = state.colorSchema[item.model] || '#ffffff';
          });
        });
      } catch (error) {
        console.error('Error loading company colors:', error);
      } finally {
        state.dataLoaded = true;
      }
    };

    onMounted(async () => {
      await loadData();
      state.colorData.forEach(cData => {
        cData.data.forEach(item => {
          item.color = state.colorSchema[item.model] || '#ffffff';
        });
      });
    });

    const editColor = (index) => {
      if (!canAlterCompanyColors.value) {
        return;
      }
      state.editMode = !state.editMode;
      state.selectedIndexforEdit = index;
    }

    const closeColorPicker = (tab, disableEditMode = false) => {
      state.colorData.forEach(cData => {
        if (cData.model === tab.model) {
          cData.data.forEach(item => {
            if (item.model === state.selectedModel) {
              item.color = state.stageColor;
            } else {
              item.color = state.colorSchema[item.model] || '#ffffff';
            }
          });
        }
      });
      if (!disableEditMode) {
        state.editMode = !state.editMode;
      }
      state.selectedIndex = null;
      state.selectedModel = '';
    }

    const openAdvancedColors = (tab) => {
      state.isAdvancedColors = !state.isAdvancedColors;
    }

    return {
      ...toRefs(state),
      canAlterCompanyColors,
      openColorPicker,
      updateColor,
      closeColorPicker,
      tabs,
      editColor,
      saveColorSchema,
      loadData,
      openAdvancedColors,
      companyId,
      setDefaultColors,
    };
  },
}

</script>

<style scoped>
.disabled-box {
  opacity: 0.5;
  pointer-events: none;
}
</style>
